var default_styles_default = {
  "button_container": "so5FK",
  "button_text": "_6e5wi",
  "button_size_content": "dIKwT"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
